<template>
   <Forms ref="frmSearch"
           title="PESQUISAR DE SOLICITAÇÕES"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           >
            <div class="form-group row">

          <div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" style="width: 100%;">
            <label class="label-search">Situação:</label>
            <select v-model="form.situacao.value" class="form-control">
                <option :value="null">Selecione</option>
                <option v-for="data in dataStatusDespesa" :key="data.value" :value="data.value">{{data.text}}</option>
            </select>
          </div>

            <label class="label-search">Funcionário:</label>
            <autocomplete-z ref="favorecidoTypeahead"
                placeholder="Digite o nome do Funcionário"
                iconClass="fas fa-id-badge"
                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                :debounceLength="3"
                :formField="form.funcionarioId"
                :returnCallback="true"
                v-on:search="onSearchFavorecido"
                v-on:changeCode="onChangeCodeFavorecido" />

          <label class="label-search">Coordenador:</label>
          <autocomplete-z ref="responsavelTypeahead"
                placeholder="Digite o nome do Responsável"
                iconClass="fas fa-users"
                :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                :debounceLength="3"
                :formField="form.coordenadorId"
                v-on:search="onSearchResponsavel"
                v-on:changeCode="onChangeCodeResponsavel" />

          <label  class="label-search">Obra:</label>
          <autocomplete-z ref="obraRHTypeahead"
              placeholder="Digite o nome da Obra"
              type="text"
              iconClass="fas fa-hard-hat"
              :serializer="(obra) => obra.referencia + ' - ' + obra.localizacao"
              :debounceLength="2"
              :formField="form.obraid"
              v-on:search="onSearchObra"
              v-on:changeCode="onChangeCodeObra"/>

          <!-- Filtro Empresa oculto (2026-06-19): despesas sao aprovadas por empresa, busca por empresa desnecessaria -->
          <div v-if="false" style="width: 100%;">
            <label  class="label-search">Empresa:</label>
            <autocomplete-z ref="empresaTypeahead"
                placeholder="Digite o nome da Empresa"
                type="text"
                iconClass="fa fa-university"
                :serializer="(empresa) => empresa.codigoZ + ' - ' + empresa.nome"
                :debounceLength="2"
                :formField="form.empresa"
                v-on:search="onSearchEmpresa"
                v-on:changeCode="onChangeCodeEmpresa"/>
          </div>

            </div>
   </Forms>
</template>

<script>
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import formdata from './form'
import ActionsForm from '@/shared/mixins/actionsForm'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ExpenseMixin from '../../mixins/ExpenseMixin'
import localStoreHelper from '@/shared/utils/localStoreHelper'
// import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm'
// import SectionRHRepository from '@/shared/http/repositories/business/sectionrh'
// import ExpenseRepository from '@/shared/http/repositories/business/expense'
// import { loading } from '@/shared/utils/UIHelper'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataStatusDespesa: [],
      form: {
        obraid: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        coordenadorId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        situacao: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        empresa: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      formOriginal: {...formdata}
    }
  },
  mounted () {
    this.GetStatusDespesa()
  },
  methods: {
    Search () {
      localStoreHelper.viagem.prestacaoContas({FuncionarioId: this.form.funcionarioId.value, Situacao: this.form.situacao.value, CoordenadorId: this.form.coordenadorId.value, EmpresaId: this.form.empresa.value, ObraId: this.form.obraid.value})
      this.$emit('search', {FuncionarioId: this.form.funcionarioId.value, Situacao: this.form.situacao.value, CoordenadorId: this.form.coordenadorId.value, EmpresaId: this.form.empresa.value, ObraId: this.form.obraid.value})
    },
    onClearSection () {
      this.form.situacao.value = null
      localStoreHelper.viagem.prestacaoContas(null)
      this.$refs.favorecidoTypeahead.clear()
      this.$refs.obraRHTypeahead.clear()
      this.$refs.responsavelTypeahead.clear()
      if (this.$refs.empresaTypeahead) {
        this.$refs.empresaTypeahead.clear()
      }
    },
    GetStatusDespesa () {
      TravelExpenseRepository.GetAllStatusDespesas()
        .then((Response) => {
          this.dataStatusDespesa.push(Response.data[9], Response.data[1], Response.data[2], Response.data[3])
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }
}
</script>

<style>
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/ExpenseSearch/ExpenseSearch.vue